import React, { useState, useEffect } from "react";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import "./PersonalDetails.css";
import { baseUrl } from "../../../Utility/constants";
import { fetchAdminSchoolId, sendWhatsAppMessage, } from "../../../Utility/constants";
import { getSchoolId } from "../../../Utility/commonFunctions";

const AddNewStudentModal = ({
  showAddNew,
  handleCloseNewStudent,
  handleNewStudentSubmit,
  newStudentItem,
  setNewStudentItem,
  adminSchoolId
}) => {
  // const [schoolList, setSchoolList] = useState([]);
  const [sessionList, setSessionList] = useState([]);
  const [genderMaster, setGenderMaster] = useState([]);
  // Fetch school details
  useEffect(() => {
  const fetchAdminData = async () => {
    try {
      //const schoolId = await getSchoolId();
      const response = await axios.get(
        `${baseUrl}/api/SchoolGeneralInfo/GetSchoolBySession?schoolId=${adminSchoolId}`
      );

      setSessionList(response.data);
    } catch (error) {
      console.error("Failed to load school details:", error);
    }
  };

  fetchAdminData();
}, []);

  // Fetch gender details
  useEffect(() => {
    axios
      .get(`${baseUrl}/api/CommonMaster/GetGenderMasters`)
      .then((response) => {
        setGenderMaster(response.data);
      })
      .catch((error) => {
        console.log("Failed to load school details.");
      });
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Check if the schoolId is being updated
    setNewStudentItem((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <Modal
      show={showAddNew}
      onHide={handleCloseNewStudent}
      dialogClassName="custom-modal-lg"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Add New Student</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleNewStudentSubmit}>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="formfirstName">
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  type="text"
                  name="firstName"
                  value={newStudentItem.firstName || ""}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="formmiddleName">
                <Form.Label>Middle Name</Form.Label>
                <Form.Control
                  type="text"
                  name="middleName"
                  value={newStudentItem.middleName || ""}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="formlastName">
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  type="text"
                  name="lastName"
                  value={newStudentItem.lastName || ""}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group controlId="formgender">
                <Form.Label>Gender</Form.Label>
                <Form.Control
                  as="select"
                  name="gender"
                  value={newStudentItem.gender || ""}
                  onChange={handleInputChange}
                >
                  <option value="">Select gender</option>
                  {
                    genderMaster.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.name}
                      </option>
                    ))
                  }

                </Form.Control>
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="formstudentContactNumber">
                <Form.Label>ContactNumber</Form.Label>
                <Form.Control
                  type="text"
                  name="studentContactNumber"
                  value={newStudentItem.studentContactNumber || ""}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>

            {/* <Col md={6}>
              <Form.Group controlId="formstudentEmail">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="text"
                  name="studentEmail"
                  value={newStudentItem.studentEmail || ""}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col> */}
            <Col md={6}>
              <Form.Group controlId="formstudentEmail">
                <Form.Label>Aadhaar Card No</Form.Label>
                <Form.Control
                  type="text"
                  name="uIDNo"
                  value={newStudentItem.uIDNo || ""}
                  onChange={handleInputChange}
                  maxLength={12}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="formpassword">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="text"
                  name="password"
                  value={newStudentItem.password || ""}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="formSessionId">
                <Form.Label>Session</Form.Label>
                <Form.Control
                  as="select"
                  name="sessionId"
                  value={newStudentItem.sessionId}
                  onChange={handleInputChange}
                >
                  <option value="">Select Session</option>
                  {sessionList && sessionList.map((session) => (
                    <option key={session.sessionId} value={session.sessionId}>
                      {session.sessionName}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>

          <Button variant="primary" type="submit">
            Save Changes
          </Button>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseNewStudent}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddNewStudentModal;
